import { Close } from '@mui/icons-material';
import { Typography, useTheme } from '@mui/material';
import { Chip } from '@shared/components';

interface Props {
  name: string;
  onDelete: () => void;
}

export const FilterChip = ({ name, onDelete }: Props) => {
  const theme = useTheme();
  const { tint } = theme.vars.palette.semantic;

  return (
    <Chip
      rounded
      backgroundColor={tint.saffron.soft}
      textColor={tint.saffron.text}
      deleteIcon={<Close />}
      onDelete={onDelete}
      label={<Typography variant="body2">{name}</Typography>}
    />
  );
};
